// src/components/common/LoadingBackdrop.jsx
import React from "react";

const LoadingBackdrop = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center transition-opacity duration-150 ease-in-out"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="w-16 h-16 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
      {/* <p className="ml-4 text-white text-lg">Loading...</p> */}
    </div>
  );
};

export default LoadingBackdrop;
